import React, { memo } from 'react';
import NotFound from '../../../assets/404.png';
import OptimXIcon from '../../../assets/greenIcon.png';
import { TEST_WEBSITE_NOT_FOUND } from '../../../catalog/Comments';
import { optimXTestWebsite } from '../../../catalog/TeamInfo';
import './css/NotFound1.css';

const NotFound1 = () => {
    return (
        <div className="not-found x-center">
            {optimXTestWebsite ? <img className="icon x-center m-t-0" src={OptimXIcon} alt="OptimX Sports" /> : null}
            <img className="not-found-image x-center m-t-5px" src={NotFound} alt="Not Found" />
            {optimXTestWebsite ? <p className="font-size-3xl">{TEST_WEBSITE_NOT_FOUND}</p> : null}
        </div>
    );
};

export default memo(NotFound1);
